import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get('/automatic-response', { params })
}

const create = (data) => {
  return axios.post(`/automatic-response`, data)
}

const update = (id, data) => {
  return axios.put(`/automatic-response/${id}`, data)
}

const deleteOne = (id) => {
  return axios.delete(`/automatic-response/${id}`)
}

const group = (data) => {
  return axios.post(`/keyword/group`, data)
}

const uploadXlsFile = (data) => {
  return axios.post(`/automatic-response/import-file`, data)
}

export default {
  create,
  getAll,
  deleteOne,
  update,
  group,
  uploadXlsFile
}